module.exports = __webpack_public_path__ + "img/powerGrid-icon_8.db941303.png";